import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/system";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useParams } from "react-router-dom";
import AddressBox from "src/components/AddressBox";
import AvoidPlans from "src/components/AvoidPlans";
import BullseyeGraph from "src/components/BullseyeGraph";
import Factors from "src/components/Factors";
import Footer from "src/components/Footer";
import Header from "src/components/Header";
import Info from "src/components/Info";
import InfoBottom from "src/components/InfoBottom";
import LearnMore from "src/components/LearnMore";
import LocationUpdater from "src/components/LocationUpdater";
import PlanComparision from "src/components/PlanComparision";
import PlanReason from "src/components/PlanReason";
import RightPlan from "src/components/RightPlan";
import SelectLanguage from "src/components/SelectLanguage";
import SplashScreen from "src/components/SplashScreen";
import ElectricityTextsContainer from "src/components/Texts/ElectricityTexts";
import { HeaderV2 } from "src/components/header_v2/Header";
import UsageModal from "src/components/widgets/UsageModal";
import constants, { competitorArray1, competitorArray2 } from "src/constants";
import { initialLoad, setViewInStore } from "src/slices/bkvReducer";
import { useDispatch, useSelector } from "src/store";

const initModal = {
  usageModal: false,
};

export type modalTypes = "usageModal" | "usageGraph" | "all";

const Home = () => {
  const theme = useTheme();
  const [modal, setModal] = useState(initModal);
  const state = useSelector((state) => state.bkv);
  const dispatch = useDispatch();
  const hasUsage = Boolean(Object.values(state.usage).length);
  const urlParam = useParams();
  const [showCompetitors, setShowCompetitiors] = useState(false);
  const searchParams = new URLSearchParams(window.location.search);

  const zipcode = searchParams.get("zipcode") ?? "77005";
  const terms = searchParams.get("terms") ?? 12;
  const [cookies] = useCookies();

  const promocode = "SEOEIQ0001";

  // New state for text visibility
  const [isTextVisible, setIsTextVisible] = useState(true);
  
  const handleOpen = (key: modalTypes) => {
    setModal({
      ...modal,
      [key]: true,
    });
  };

  const handleClose = (key: modalTypes) => {
    if (key === "all") {
      setModal(initModal);
    } else {
      setModal({
        ...modal,
        [key]: false,
      });
      if (key === "usageModal") {
        dispatch(setViewInStore("options"));
      }
    }
  };

  // New function to handle personalization
  const handlePersonalize = () => {
    setIsTextVisible(false);
  };

  const Container = styled("div")({
    width: "100%",
    height: "auto",
  });
  const [isLocationFetched, setIsLocationFetched] = useState(false);

  useEffect(() => {
    if (
      !competitorArray1.includes(urlParam.planType) &&
      !competitorArray2.includes(urlParam.planType)
    ) {
      window.location.href = `${window.origin}/${constants.routeToPlan}?zipcode=${zipcode}`;
    } else {
      let is_competitor = false;
      if (competitorArray1.includes(urlParam.planType)) {
        is_competitor = true;
      }
      setShowCompetitiors(is_competitor);
      if (isLocationFetched)
        dispatch(
          initialLoad(
            urlParam.planType,
            Number(zipcode),
            terms,
            is_competitor,
            promocode
          )
        );
    }
  }, [urlParam.planType, state.gimmicky, isLocationFetched]);

  // Reset text visibility when component mounts
  useEffect(() => {
    setIsTextVisible(true);
  }, []);

  return (
    <>
      <LocationUpdater setIsLocationFetched={setIsLocationFetched} />
      {state.appLoading || !isLocationFetched ? (
        <SplashScreen loading={state.appLoading || !isLocationFetched} />
      ) : (
        <Container>
          <UsageModal
            open={modal.usageModal}
            handleClose={(key) => handleClose(key)}
          />
          <HeaderV2 />
          <Header hasUsage={hasUsage} content={state.content?.value[0]} />
          <Info content={state.content?.value[1]} />
          {isTextVisible && <ElectricityTextsContainer />}

          <BullseyeGraph
            handleOpen={(key) => handleOpen(key)}
            content={state.content?.value[2]}
            showCompetitorTable={showCompetitors}
            type={state.type}
          />
          <AddressBox
            handleOpen={(key) => handleOpen(key)}
            content={state.content?.value[2]}
            onPersonalize={handlePersonalize}
          />
          <RightPlan content={state.content?.value[2]} />
          <Factors content={state.content?.value[3]} />
          <PlanComparision content={state.content?.value[4]} />
          <AvoidPlans content={state.content?.value[5]} />
          <PlanReason content={state.content?.value[6]} />
          <InfoBottom content={state.content?.value[7]} />
          <LearnMore />
          <SelectLanguage />
          <Footer />
        </Container>
      )}
    </>
  );
};

export default Home;
